import React from 'react';
import { scrollToCompra, OLD_PRICE, PRICE } from '../lib/constants';
export function StickyCTA() {
  return <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-[#06181d]/95 px-3 py-2.5 backdrop-blur" data-id="element-168" data-mp="1cid87zixv0v9">
      <div className="mx-auto flex max-w-md items-center gap-3" data-id="element-169" data-mp="yj56ayve5end">
        <div className="flex-none leading-tight" data-id="element-170" data-mp="12imfo3dxuvxt">
          <p className="text-[10.5px] text-teal-100/60 line-through" data-id="element-171" data-mp="12l8jbrxpkrar">
            {OLD_PRICE}
          </p>
          <p className="font-display text-lg font-extrabold text-white" data-id="element-172" data-mp="1qatd75veh8yt">
            {PRICE}
          </p>
        </div>
        <button type="button" onClick={scrollToCompra} className="flex-1 rounded-lg bg-[#e8590c] px-4 py-3 font-display text-[13px] font-extrabold uppercase tracking-wide text-white shadow-lg shadow-orange-900/40 hover:bg-[#d24f08] focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-300" data-id="element-173" data-mp="1hgoi2a98hbdh">
          Resolvé tus clases hoy
        </button>
      </div>
    </div>;
}